// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"891":"798e63d8","1248":"73736d69","3356":"39aa7832","4481":"612bd41a","5263":"88bfd26d"}[chunkId] + ".chunk.css";
};